/**
 * Finds the namespace declaration in a C# token stream — supports both
 * block-scoped (`namespace X.Y.Z { ... }`) and file-scoped (`namespace X.Y.Z;`)
 * syntax, since the token stream doesn't care which follows the identifier
 * chain. Only the first `namespace` keyword is used — a pasted file has one.
 * @param {{type: string, value: string}[]} tokens
 * @returns {string|null} dotted namespace string, or null if none found
 */
export function scanNamespace(tokens) {
  const i = tokens.findIndex(function isNamespaceKeyword(t) {
    return t.type === 'identifier' && t.value === 'namespace';
  });
  if (i === -1) return null;

  let j = i + 1;
  let name = '';
  while (tokens[j] && (tokens[j].type === 'identifier' || tokens[j].value === '.')) {
    name += tokens[j].value;
    j += 1;
  }
  return name || null;
}
